module.exports = __webpack_public_path__ + "img/icon-42.db39d65c.png";